import murmurhash from 'murmurhash-js';
import { isObject } from 'lodash';

const HASH_KEY = 0x9747b28c;

// noinspection SpellCheckingInspection
const INITIAL_DATA = {
    __jstorage_meta: {
        CRC32: {},
        TTL: {}
    }
};

export class JStorageService {
    get(key) {
        return this.getDataFromStorage()[key];
    }

    set(key, value) {
        const jStorage = this.getDataFromStorage();

        jStorage[key] = value;
        jStorage.__jstorage_meta.CRC32[key] = this.calculateChecksum(value);

        localStorage.setItem('jStorage', JSON.stringify(jStorage));
    }

    setMultiple(changes: Record<string, any>) {
        Object.keys(changes).forEach(key => this.set(key, changes[key]));
    }

    deleteKey(key) {
        const jStorage = this.getDataFromStorage();

        delete jStorage[key];
        delete jStorage.__jstorage_meta.CRC32[key];

        localStorage.setItem('jStorage', JSON.stringify(jStorage));
    }

    clear() {
        // Remove the persisted blob
        localStorage.removeItem('jStorage');

        // If the legacy jStorage library is loaded on this page, flush its in-memory cache
        // and force it to re-initialise so that any Angular code running in the same
        // context immediately sees an empty store.
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const legacyJStorage = window.$?.jStorage;
        if (legacyJStorage) {
            legacyJStorage.flush();
            legacyJStorage.reInit();
        }
    }

    private getDataFromStorage() {
        const jStorageStr = localStorage.getItem('jStorage');
        if (!jStorageStr) {
            return { ...INITIAL_DATA };
        }

        const jStorageObject = JSON.parse(jStorageStr);

        if (!isObject(jStorageObject)) {
            return { ...INITIAL_DATA };
        }

        if (!jStorageObject.hasOwnProperty('__jstorage_meta')) {
            return { ...INITIAL_DATA, ...jStorageObject };
        }

        return JSON.parse(jStorageStr);
    }

    private calculateChecksum(value: string) {
        const resultHash = murmurhash.murmur2(JSON.stringify(value), HASH_KEY);

        return `2.${resultHash}`;
    }
}
